// This follows the method here: https://github.com/styled-components/styled-components/issues/887#issuecomment-376858712
// eslint-disable-next-line no-undef
__webpack_nonce__ = window.__webpack_nonce__;
